/**
 * FORCE brand lockup — orange handshake mark + FORCE wordmark.
 * layout: "horizontal" (default) or "vertical" (stacked, for the login box).
 */
export function ForceLogo({ size = 40, layout = "horizontal", className = "" }) {
    const vertical = layout === "vertical";
    const textSize = Math.round(size * (vertical ? 0.62 : 0.6));
    return (
        <div
            className={`inline-flex items-center ${vertical ? "flex-col gap-2" : "flex-row gap-2.5"} ${className}`}
        >
            <img
                src="/force-mark.png"
                alt="FORCE"
                style={{ width: size, height: size }}
                className="object-contain drop-shadow-[0_0_14px_rgba(255,122,0,0.5)]"
            />
            <span
                className="font-display font-black leading-none tracking-[0.14em] text-orange-500"
                style={{ fontSize: textSize }}
            >
                FORCE
            </span>
        </div>
    );
}
